import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { Store } from '@ngrx/store';
import { gateway } from 'libs/generated-grpc-web';

import { FirebaseMessaging } from '@app/src/app/firebase/messaging';
import { AnalyticsService } from '@app/src/app/minimal/services/Analytics';
import { BadgeNotificationHandlerService } from '@app/src/app/notifications/badge';
import { NotificationClickHandler } from '@app/src/app/notifications/clickHandler';
import { PointsNotificationHandlerService } from '@app/src/app/notifications/points';
import { RosteringNotificationHandlerService } from '@app/src/app/notifications/rostering';
import { NotificationBadgeSyncService } from '@app/src/app/services/NotificationBadgeSync';
import { NotificationActions } from '@app/src/app/store/Notifications/actions';
import { NotificationStoreModel } from '@app/src/app/store/Notifications/model';

import { NotificationDataSource } from './NotificationDataSource';

@Component({
  selector: 'mg-notifications',
  templateUrl: './Notifications.component.html',
  styleUrls: ['./Notifications.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [NotificationDataSource],
})
export class NotificationsComponent implements OnInit {
  constructor(
    public ds: NotificationDataSource,
    public notificationManager: gateway.notification_ng_grpc_pb.NotificationManager,
    private _notificationBadgeSync: NotificationBadgeSyncService,
    private _store: Store<any>,
    private _firebaseMessaging: FirebaseMessaging,
    private _notificationClickHandler: NotificationClickHandler,
    private _analyticsService: AnalyticsService,
    private _pointsNotificationHandler: PointsNotificationHandlerService,
    private _badgeNotificationHandler: BadgeNotificationHandlerService,
    private _rosteringNotificationHandler: RosteringNotificationHandlerService,
  ) {}

  ngOnInit() {
    this._firebaseMessaging.requestPermission();
    this._notificationBadgeSync.clearBadgeCount();
    this._store.dispatch(new NotificationActions.ViewedNotificationsAction());
  }

  notificationItemClick(notification: gateway.notification_pb.Notification) {
    const item = notification.toObject();

    if (!notification.getRead()) {
      // Fire, forget!
      notification.setRead(true);
      notification.setViewed(true);
      const storeModel: NotificationStoreModel = {
        id: item.notificationId,
      };
      const notificationType = item.notificationType;

      if (item.actionGalleryPhoto) {
        const groupHash = item.actionGroupContent?.groupHash;
        storeModel.groupHash = groupHash;
      } else if (this._pointsNotificationHandler.isPointsNotification(notificationType)) {
        this._pointsNotificationHandler.handleDisplayPointNotification(item);
      } else if (this._badgeNotificationHandler.isBadgeNotification(notificationType)) {
        this._badgeNotificationHandler.handleDisplayBadgeNotification(item);
      } else if (this._rosteringNotificationHandler.isRosteringNotification(notificationType)) {
        this._rosteringNotificationHandler.handleNotification();
      }

      this._store.dispatch(new NotificationActions.MarkNotificationAsReadAction(storeModel));
    }

    this._notificationClickHandler.clickNotification(item);
    this._analyticsService.sendNotificationOpened(notification.getActionCase());
  }
}
